import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import it from './locales/it.json';
import nl from './locales/nl.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import ar from './locales/ar.json';
import hi from './locales/hi.json';
import tr from './locales/tr.json';
import ru from './locales/ru.json';
import pl from './locales/pl.json';
import sv from './locales/sv.json';

export const LANGUAGES = [
  { code: 'en', name: 'English', flag: 'GB' },
  { code: 'de', name: 'Deutsch', flag: 'DE' },
  { code: 'fr', name: 'Francais', flag: 'FR' },
  { code: 'es', name: 'Espanol', flag: 'ES' },
  { code: 'pt', name: 'Portugues', flag: 'PT' },
  { code: 'it', name: 'Italiano', flag: 'IT' },
  { code: 'nl', name: 'Nederlands', flag: 'NL' },
  { code: 'zh', name: 'Chinese', flag: 'CN' },
  { code: 'ja', name: 'Japanese', flag: 'JP' },
  { code: 'ko', name: 'Korean', flag: 'KR' },
  { code: 'ar', name: 'Arabic', flag: 'SA', dir: 'rtl' },
  { code: 'hi', name: 'Hindi', flag: 'IN' },
  { code: 'tr', name: 'Turkce', flag: 'TR' },
  { code: 'ru', name: 'Russian', flag: 'RU' },
  { code: 'pl', name: 'Polski', flag: 'PL' },
  { code: 'sv', name: 'Svenska', flag: 'SE' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, de: { translation: de }, fr: { translation: fr }, es: { translation: es }, pt: { translation: pt }, it: { translation: it }, nl: { translation: nl }, zh: { translation: zh }, ja: { translation: ja }, ko: { translation: ko }, ar: { translation: ar }, hi: { translation: hi }, tr: { translation: tr }, ru: { translation: ru }, pl: { translation: pl }, sv: { translation: sv } },
    fallbackLng: 'en',
    supportedLngs: ['en','de','fr','es','pt','it','nl','zh','ja','ko','ar','hi','tr','ru','pl','sv'],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'pushpro_lang',
    },
  });

export default i18n;
